module.exports = __webpack_public_path__ + "img/undraw.da4a8930.png";